import { getDeliveryShopId } from '@epicuro-next/utilities';

import { BusinessState, DeliveryItem } from '../../models';
import { getSelectedDeliveryPeriod } from '../../shared/get-selected-delivery-period';

export function productNoteChangeBusiness(
  state: BusinessState,
  { productId, note }: { productId: string; note: string },
): BusinessState {
  const deliveryShopKey = getDeliveryShopId(state.activeDeliveryShop);
  const deliveryPeriod = getSelectedDeliveryPeriod(state);
  const deliveryItems = { ...state.deliveryItems };
  const deliveryShopItems = { ...deliveryItems[deliveryShopKey] };
  const deliveryPeriodItems = { ...deliveryShopItems[deliveryPeriod] };

  const stateDeliveryItem: DeliveryItem | undefined =
    deliveryPeriodItems.items?.[productId];
  if (stateDeliveryItem?.note === note) {
    return state;
  }

  const deliveryItem = stateDeliveryItem ?? { quantity: 0 };
  const isStateDirty = state.dirty;
  // if stateDeliveryItem is not 0 and note has changed, then it has to be dirty
  // so user can update his basket
  const isDirty = isStateDirty
    ? isStateDirty
    : !!stateDeliveryItem && stateDeliveryItem?.quantity !== 0;

  deliveryItems[deliveryShopKey] = {
    ...deliveryItems[deliveryShopKey],
    [deliveryPeriod]: {
      ...deliveryPeriodItems,
      items: {
        ...deliveryPeriodItems.items,
        [productId]: {
          ...deliveryItem,
          note,
        },
      },
    },
  };

  return {
    ...state,
    deliveryItems: {
      ...state.deliveryItems,
      ...deliveryItems,
    },
    dirty: isDirty,
  };
}
